var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "giftsHead"
  }, [_c('div', {
    staticClass: "giftsHead-main"
  }, [_c('div', {
    staticClass: "balance"
  }, [_vm.balance.stock.icon ? _c('div', {
    staticClass: "balance-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.balance.stock.icon,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.balance.stock.balance)))])]) : _vm._e(), _vm.balance.ton.icon ? _c('div', {
    staticClass: "balance-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.balance.ton.icon,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.balance.ton.balance)))])]) : _vm._e(), _vm.balance.tap.icon ? _c('div', {
    staticClass: "balance-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.balance.tap.icon,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.balance.tap.balance)))])]) : _vm._e(), _vm.balance.Stars.icon ? _c('div', {
    staticClass: "balance-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.balance.Stars.icon,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.balance.Stars.balance)))])]) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };